/**
 * Refresh signal — emitted after every successful mutation so any listening
 * component (the timeline card + the hydration/sleep card share a doc) can
 * reload from the server. Same pattern as ALG_V2_REFRESH / ACT_V2_REFRESH.
 */
export const DS_V2_REFRESH = "DAILY_SCHEDULE_V2_REFRESH";
